"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteScheduleConfirmDialog = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
exports.DeleteScheduleConfirmDialog = function (props) {
    var scheduledEmail = props.scheduledEmail, onCancel = props.onCancel, onSuccess = props.onSuccess, onError = props.onError;
    var ref = scheduledEmail.ref, subject = scheduledEmail.subject;
    var effectiveBackend = sdk_ui_1.useBackendStrict();
    var effectiveWorkspace = sdk_ui_1.useWorkspaceStrict();
    var intl = react_intl_1.useIntl();
    var handleDeleteScheduledMail = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, effectiveBackend.workspace(effectiveWorkspace).dashboards().deleteScheduledMail(ref)];
                case 1:
                    _a.sent();
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    onError === null || onError === void 0 ? void 0 : onError(err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(sdk_ui_kit_1.ConfirmDialog, { displayCloseButton: true, isPositive: false, headline: intl.formatMessage({ id: "dialogs.schedule.management.delete.dialog" }), cancelButtonText: intl.formatMessage({ id: "cancel" }), submitButtonText: intl.formatMessage({ id: "delete" }), onSubmit: handleDeleteScheduledMail, onClose: onCancel, onCancel: onCancel, className: "gd-scheduled-email-delete-dialog s-scheduled-email-delete-dialog", containerClassName: "gd-scheduled-email-delete-dialog-overlay" },
        react_1.default.createElement("span", { className: "s-scheduled-email-delete-dialog-content" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "dialogs.schedule.management.delete.dialog.confirm", values: {
                    b: function (chunks) { return (react_1.default.createElement("span", { className: "gd-scheduled-email-delete-dialog-text" },
                        chunks,
                        " ",
                        react_1.default.createElement("strong", null, subject))); },
                } }))));
};
//# sourceMappingURL=DeleteScheduleConfirmDialog.js.map